module.exports = __webpack_public_path__ + "static/media/MN.6d823eb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MN.svg
// module id = 315
// module chunks = 0